import { render, staticRenderFns } from "./DeletePlanningTaskModal.vue?vue&type=template&id=774e2078"
import script from "./DeletePlanningTaskModal.vue?vue&type=script&lang=js"
export * from "./DeletePlanningTaskModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports